import { Component, HostListener, OnInit, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {map, mergeMap, tap} from 'rxjs/operators';
import {Prestatie} from '../../../prestatie/prestatie';
import {PrestatieService} from '../../../prestatie/prestatie.service';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Clientnummer} from '../../../client/clientnummer-selector/clientnummer';
import {NotificationService} from '../../../core/notification/notification.service';
import {Location} from '@angular/common';

@Component({
    templateUrl: './stop-prestatie.page.html',
    styleUrls: ['./stop-prestatie.page.scss'],
    standalone: false
})
export class StopPrestatiePage implements OnInit {
  private prestatieService = inject(PrestatieService);
  private clientService = inject(ClientService);
  private notificationService = inject(NotificationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);

  prestatie$: Observable<Prestatie>;
  client$: Observable<Client>;

  @HostListener('window:focus') onFocus() {
    window.location.reload();
  }

  ngOnInit(): void {
    this.prestatie$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.prestatieService.getPrestatie$(id)),
      );
    this.client$ = this.prestatie$.pipe(
      mergeMap(prestatie => this.clientService.getClientById$(prestatie.getClientId()))
    );
  }

  stopPrestatie(prestatie: Prestatie, client: Client, clientnummer: Clientnummer): void {
    if (client.getNummer() !== clientnummer.nummer) {
      this.notificationService.showWarning('De gescande QR code of ingegeven cliëntnummer komt niet overeen met de huidige prestatie.');
    } else {
      this.prestatieService.stopPrestatie$(prestatie.getId(), clientnummer.zoekMethode)
        .pipe(tap(() => this.notificationService.showSuccess(`Prestatie en alle uitgevoerde<br>taken succesvol bewaard`)))
        .subscribe(() => this.router.navigateByUrl('/prestatie/start'));
    }
  }

  navigateBack(): void {
    this.location.back();
  }
}
